class PrintBarcodesController {
    /*@ngInject*/
    constructor($state, $stateParams, $translate) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.model = {
            shipmentDetails: [],
            barcodeOptions:
            {
                format: 'CODE128', lineColor: '#030303', width: 3, height: 120, displayValue: true,
                font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 20,
                marginTop: 0, marginBottom: 0
                // background: '#ffffff', margin: 0, marginTop: undefined, marginBottom: undefined, marginLeft: undefined,
                // marginRight: undefined, valid: function (valid) { }
            }
        }
    }

    $onInit() {
        let printData = undefined;
        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;
            this.model.shipmentDetails = printData.shipmentDetails;
            this.model.isPrePackPrint = printData.isPrePackPrint;
            this.model.barcodeOptions.displayValue = !printData.isPrePackPrint;
            this.model.multiDenomPack = printData.multiDenomPack;
            this.model.depositShipmentLabelPrePack = printData.depositShipmentLabelPrePack;
            this.currencySymbol = printData.currencySymbol || '$';
            setTimeout(() => {
                window.print();
            }, 2000)
        }
    }

    formatLocationAddress(obj) {
        let locationAddress = '';
        if (obj.address) {
            locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.address);
        }
        if (obj.city) {
            locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.city);
        }
        if (obj.state) {
            locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.state);
        }
        if (obj.zip) {
            locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.zip);
        }
        return locationAddress;
    }

    getOrderType(obj) {
        if (obj.orderType) {
            const key = 'shipment.order_type_' + obj.orderType;
            const translated = this.$translate.instant(key);
            return translated !== key ? translated : obj.orderType;
        }
        return obj.shiptypeId || '';
    }
}

export default PrintBarcodesController;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_barcodes/print_barcodes.controller.js